import { CommonModule, CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, inject, Inject, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCommonModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ICartItem } from '../cart-qty-control/cart-qty-control.component';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppMessageService } from '../../app.message.service';
import { ItemService } from '../item-detail/item-detail.service';
import saveAs from 'file-saver';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FooterComponent } from '../../shared/footer/footer.component';
import { ReCaptchaV3Service, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';
import { MatTooltipModule } from '@angular/material/tooltip';
import { APPHOST } from '../../app.component';
import { CreatePaymentSessionRequest, CustomerInfo, PayPlusService } from '../../payplus.service';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { PaymentReceivedComponent } from '../payment-received/payment-received.component';

@Component({
  selector: 'app-cart-control',
  standalone: true,
  imports: [CommonModule, MatCommonModule, RecaptchaV3Module, MatTooltipModule,
    RecaptchaModule, MatIconModule, RouterModule, FooterComponent,
    MatButtonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './cart-control.component.html',
  styleUrl: './cart-control.component.scss',
  providers: [
    CurrencyPipe
  ]
})
export class CartControlComponent {
  g: ICartItem[] = [];
  total = 0;
  preparing: boolean = false;

  name = new FormControl('')
  phoneNumber = new FormControl('')
  email = new FormControl('')
  passKey: string = '';

  readonly matdialog = inject(MatDialog);
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private itemService: ItemService,
    private location: Location,
    private payplusService: PayPlusService,
    private changeDetectorRef: ChangeDetectorRef, private recaptchaV3Service: ReCaptchaV3Service,
    private currencyPipe: CurrencyPipe,
    private activatedRoure: ActivatedRoute,

    private msgService: AppMessageService) {

    activatedRoure.queryParams.subscribe(w => {
      if (w['orderId']) {
        this.recaptchaV3Service.execute('importantAction')
          .subscribe((token) => {


            itemService.getQuotationBody(w['orderId']).subscribe(ew => {
              itemService.patchQuotation({ ...ew.body, orderStatus: 'PAID', paid: true }).subscribe(ee => {

               const d = this.matdialog.open(PaymentReceivedComponent, {
                  width: '500px',
                  // height: '500px',

                  hasBackdrop: true,
                  disableClose: false

                });

              })

            })


          });

      }
      console.log(w);

    })

    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('sfncart')) {
        this.g = JSON.parse(localStorage.getItem('sfncart') as string);
        this.getTotal()

      } else {
        localStorage.setItem('sfncart', JSON.stringify([]))
        this.g = JSON.parse(localStorage.getItem('sfncart') as string);
        this.getTotal()
      }


    }
  }

  @HostListener('window:keydown.Shift.S', ['$event'])
  deployS() {
    this.passKey = 'S'

  }

  @HostListener('window:keydown.Shift.O', ['$event'])
  deployO() {
    this.passKey += 'O'
  }

  @HostListener('window:keydown.Shift.F', ['$event'])
  deployF() {
    this.passKey += 'F'
  }

  @HostListener('window:keydown.Shift.T', ['$event'])
  deployT() {
    this.passKey += 'T'
    if (this.passKey === 'SOFTNET') {
      alert('DEPLOYING...')
      this.itemService.cicdhc().subscribe(w => {
        alert(w.body)
      })
    }
  }

  @HostListener('window:keydown.Shift.N', ['$event'])
  deployN() {
    this.passKey += 'N'
  }


  @HostListener('window:keydown.Shift.E', ['$event'])
  deployE() {
    this.passKey += 'E'
  }




  downloadCart(e: any, buy: boolean = false) {
    this.preparing = true;
    if (isPlatformBrowser(this.platformId)) {
      var dt = new Date();

      const year = dt.getFullYear();
      const month = (dt.getMonth() + 1).toString().padStart(2, "0");
      const day = dt.getDate().toString().padStart(2, "0");
      const qid = (buy ? 'QORD-' : '') + year + month + day + dt.getHours().toString().padStart(2, "0") + '-' + this.makeRandomId(4);
      const total = this.currencyPipe.transform(this.getTotal(), 'Rs.')!
      const items = (JSON.parse(localStorage.getItem('sfncart')!) as ICartItem[]);
      let d: any;
      if (this.name.value!.length > 0) {

        d = {
          "date": day + '-' + month + '-' + year,
          "itemsTotal": this.currencyPipe.transform(this.getTotal(), 'Rs.')!,
          qid: qid,
          "records": [
            ...items
          ]
        };
        this.recaptchaV3Service.execute('importantAction')
          .subscribe((token) => {


            this.itemService.postQuotation({
              "customerName": this.name.value,
              "phoneNumber": this.phoneNumber.value,
              "email": this.email.value,
              "qid": qid,
              "createdDate": this.getFormattedDate(),
              "pdf": JSON.stringify(d, null, 2),
              'requestType': buy ? 'ONLINE_ORDER' : 'QUOTATION'

            }, token).subscribe(www => {
              const ph = this.phoneNumber.value!.charAt(0) === '0' ? this.phoneNumber.value?.substring(1, this.phoneNumber.value.length) : this.phoneNumber.value

              const result: CustomerInfo = {
                firstname: this.name.value?.split(' ')[0],
                lastname: this.name.value?.split(' ').length! > 1 ? this.name.value?.split(' ')[1] : ' ',
                phoneNumber: ph?.toString(),
                email: this.email.value!,
                dialCode: '+94',
              }

              const orderId = qid;
              const amount = this.getTotal();
              const description = items.length + ' items worth over ' + amount;
              const redirectUrl = APPHOST + this.location.path() + '?orderStatus=SUCCESS&orderId=' + www.body.id;
              const source = 'ANGULAR_JS';

              const paymentSessionRequest: CreatePaymentSessionRequest = {
                amount,
                orderId,
                redirectUrl,
                applicationKey: environment.payplus.applicationKey,
                domain: 'softnetcomputers.lk',
                source,
                description,
                paymentType: 'ONE_TIME',
                currency: 'LKR',
                platformType: 'WEB',
                customerInfo: result,

              };

              if (buy) {
                this.payplusService.createPaymentSession({ ...paymentSessionRequest })
                  .subscribe({
                    next: (res) => {
                      const link = res.body?.data.link;
                      const token = res.body?.data.token;
                      if (res.body?.data.link) {
                        window.open(link)
                      } else {

                      }
                    },
                    error: (e) => {

                    }

                  })
              }

              this.itemService.getQuotation(
                d
              ).subscribe(b => {

                // console.log(d.body.text)
                const blob = b.body;

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob!);
                const pdfFileName = 'generated by softnetcomputers.lk web.pdf';
                saveAs(blob!, pdfFileName);
                this.preparing = false;
                this.changeDetectorRef.detectChanges()
              });

            })

          });



      } else {
        d = {
          "date": day + '-' + month + '-' + year,
          "itemsTotal": this.currencyPipe.transform(this.getTotal(), 'Rs.')!,
          "qid": null,
          "records": [
            ...(JSON.parse(localStorage.getItem('sfncart')!) as ICartItem[])
          ]
        }
        this.itemService.getQuotation(

          d

        ).subscribe(b => {

          // console.log(d.body.text)
          const blob = b.body;

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob!);
          const pdfFileName = 'generated by softnetcomputers.lk web.pdf';
          saveAs(blob!, pdfFileName);
          this.preparing = false;
          this.changeDetectorRef.detectChanges()


        });
      }





    }
  }

  getFormattedDate() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }


  makeRandomId = (length: number) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
  reduce(i: ICartItem) {
    i.quantity! -= 1;
    i.total = this.currencyPipe.transform(Number(i.unitPrice!.replace('Rs.', '').replaceAll(',', '')) * i.quantity!, 'Rs.')!;



    localStorage.setItem('sfncart', JSON
      .stringify(this.g))
    localStorage.setItem('total', this.g.reduce((c, p) => c + Number(p.total!.replace('Rs.', '').replaceAll(',', '')), 0).toString())
    this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))
    this.getTotal();

  }
  increase(i: ICartItem) {
    i.quantity! += 1;
    i.total = this.currencyPipe.transform(Number(i.unitPrice!.replace('Rs.', '').replaceAll(',', '')) * i.quantity!, 'Rs.')!;

    localStorage.setItem('sfncart', JSON
      .stringify(this.g))
    localStorage.setItem('total', this.g.reduce((c, p) => c + Number(p.total!.replace('Rs.', '').replaceAll(',', '')), 0).toString())
    this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))
    this.getTotal();

  }

  getTotal(): number {
    this.total = Number(localStorage.getItem('total'))
    return this.total;
  }
  deleteItem(i: number) {
    this.g.splice(i, 1);
    localStorage.setItem('sfncart', JSON
      .stringify(this.g))
    localStorage.setItem('total', this.g.reduce((c, p) => c + Number(p.total!.replace('Rs.', '').replaceAll(',', '')), 0).toString())
    this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))
    this.getTotal();
  }

  formValid() {
    return this.name.value!.length > 0 && this.phoneNumber.value!.length > 0 && this.email.value!.length > 0
  }
  getHost(): string {
    return APPHOST;
  }
  purchaseNow(e: any) {
    this.downloadCart(e, true)

  }
}
